import React from "react";
import { Img } from "../Img";
export const WideCard = ({ imgUrl, alt, subTitle, title, cardUrl, cardNumber }) => (React.createElement("a", { href: cardUrl, target: "_blank", className: cardNumber === 1 ? "wide-card-container one-card-version" : "wide-card-container", rel: "noopener noreferrer" },
    React.createElement(Img, { src: imgUrl, alt: alt }),
    React.createElement("div", { className: "wide-card-container__titleWrapper" },
        React.createElement("h4", null, title),
        React.createElement("p", null, subTitle))));
